export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-w@2x.f5b79587.png";